import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ExternalRequestService } from '../external-request.service';
import * as _ from 'lodash';
import { IClient } from '../../../../admin/clients-page/clients/clients.interface';
import { AuthService } from '../../../services/auth.service';
import { AlertService } from '../../../services/alert.service';
import { UtilsService } from '../../../services/utils.service';
import { IAgent } from '../../../../admin/agents-page/agents/agents.interface';
import { ITask } from '../../../../admin/tasks-page/tasks/task.interface';

let self: any;

@Component({
  selector: 'app-external-request-modal',
  templateUrl: './external-request-modal.component.html',
  styleUrls: ['./external-request-modal.component.css']
})
export class ExternalRequestModalComponent implements OnInit {
  dialog: MatDialogRef<any>;
  submitted = false;
  isDev!: boolean;

  client!: IClient;
  task!: ITask;
  agent!: IAgent;
  noAgent!: boolean;

  taskByDate = {
    scheduledStart: new Date().toISOString().substring(0, 10),
    scheduledEnd: new Date().toISOString().substring(0, 10),
  };

  link: string = "";

  constructor(
    private _ExternalRequestService: ExternalRequestService,
    private _AuthService: AuthService,
    public _AlertService: AlertService,
    public _UtilsService: UtilsService,
    private _dialogRef: MatDialogRef<any>,
  ) {
    self = this;
    this.dialog = _dialogRef;
  }

  ngOnInit(): void {
    this.isDev = this._AuthService.isRole('dev');
  }

  copyLink() {
    navigator.clipboard.writeText(this.link);
    this._AlertService.info('enlace copiado!');
  }

  async generateTaskByDateLink() {
    const start = this._UtilsService.date.toUTC(this.taskByDate.scheduledStart + 'T00:00:00.000Z');
    const end = this._UtilsService.date.toUTC(this.taskByDate.scheduledEnd + 'T23:59:59.999Z');
    const response = await this._ExternalRequestService.getClientTasks(this.client, start, end);
    this.link = this._ExternalRequestService.getExternalRequestUrl(response._id);
  }

  async generateSingleTaskLink() {
    const response = await this._ExternalRequestService.getSingleTask(this.task);
    this.link = this._ExternalRequestService.getExternalRequestUrl(response._id);
  }

  async generateDeliveryNoteLink() {
    const response = await this._ExternalRequestService.getDeliveryNote(this.task.deliverynote);
    this.link = this._ExternalRequestService.getExternalRequestUrl(response._id);
  }

  async generateTaskRequestsLink() {
    const response = await this._ExternalRequestService.getTaskRequest(this.agent);
    this.link = this._ExternalRequestService.getExternalRequestUrl(response._id);
  }

  async generateGenericTaskRequestsLink() {
    const response = await this._ExternalRequestService.getTaskRequest(null);
    this.link = this._ExternalRequestService.getExternalRequestUrl(response._id);
  }
}